module.exports = __webpack_public_path__ + "img/home-slider1.be803516.jpg";